import React, { useState, useEffect } from 'react'
import styles from './hrisIntegration.module.scss'
import { Col, Row} from 'react-bootstrap';
import { CustomButton } from '../../../shared/customButton';
import CSSLoader from '../../../shared/cssLoader';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import { CustomTextField } from '../../../shared/customTextField'
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import { CustomStatusLabel} from '../../../shared/customStatusLabel';
import { CustomIconButton } from '../../../shared/customIconButton';
import { CustomSwitchButtonRow } from '../../../shared/customSwitchButtonRow';
import { Formik, Form, FieldArray } from 'formik';

import JSONInput from "react-json-editor-ajrm";
import locale from 'react-json-editor-ajrm/locale/en'
import { getHrisData, submitDisableHrisConnection, submitHrisConfigsAndConnect, submitDisconnectHrisConnection, submitEnableHrisConnection, EditHrisConfigsAndConnect } from '../../../../services/util/company';
import * as yup from 'yup';





function HrisIntegration(props) {

    const [isEditMode, setIsEditMode] = useState(false);
    const [showDisableModal, setShowDisableModal] = useState(false);
    const [showEnableModal, setShowEnableModal] = useState(false);
    const [showDisconnectModal, setShowDisconnectModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [submitDetails, setSubmitDetails] = useState();
    const [isDataLoading, setDataLoading] = useState(false);
    const [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);

    //default value for jsonBodyMapping
    let defaultHRISRequestJsonBody = {
        first_name: "{first_name}",
        last_name: "{last_name}",
    }

    let editModeBodyMappingPlaceholder = defaultHRISRequestJsonBody;
    let editModeBodyMappingData = JSON.stringify(defaultHRISRequestJsonBody);

    const [apiurl, setAPIurl] = useState("");
    const [bodyMappingdata, setBodyMapping] = useState(defaultHRISRequestJsonBody);
    const [successCode, setSuccessCode] = useState("");
    const [headersdata, setHeaders] = useState([]);

    const [isWebhookEnable, setWebhookEnable] = useState(false);
    const [isWebhookConnect, setWebhookConnect] = useState(false);


    const [editDetails, setEditDetails] = useState();


    //form validation without json editor
    const schema = yup.object({
        APIendpoint: yup.string().matches(
            /((https?):\/\/)/,
            'Enter correct url'
        ).required('Required'),
        headers: yup.array().of(
            yup.object().shape({
                key: yup.string().required('Required'),
                value: yup.string().required('Required')

            })
        ),
        successCode: yup.number().typeError('Only numbers allowed').required('Required'),

    })

    //open diable modal
    const onClickDisable = () => {
        if (props.main_props.permissions.actions.edit_settings === true) {
            setShowDisableModal(true);
        }
    }

    const onClickEnable = () => {
        if (props.main_props.permissions.actions.edit_settings === true ) {
            setShowEnableModal(true);
        }
    }

    const handleClose = () => {
        setShowDisableModal(false);
        setShowEnableModal(false);
        setShowDisconnectModal(false);
        setShowConfirmModal(false);
    }

    //open disconnect modal
    const onClickDisconnect = () => {
        if (props.main_props.permissions.actions.edit_settings === true  ) {
            setShowDisconnectModal(true);
        }
    }

    const onUpdateCompleted = (values) => {
        // if no syntax errors       
        if (!values.error) {
            if (values.json && values.json.length > 0) {  //if empty string entered             
                editModeBodyMappingData = values.json;
            }
            else {
                editModeBodyMappingData = null;
            }
        } else {
            editModeBodyMappingData = null;
        }
    }


    //form values and json editor values set here
    const onSubmitConnect = async (values) => {
        if (editModeBodyMappingData) {
            let hrisSubmitData = {
                headers: values.headers,
                APIendpoint: values.APIendpoint,
                successCode: values.successCode,
                bodyMapping: editModeBodyMappingData,
            }
            setSubmitDetails(hrisSubmitData);
            setShowConfirmModal(true);
        }
    }

    //form values and json editor values set here
    const onSubmitEdit = async (values) => {
        if (editModeBodyMappingData) {
            let hrisEditData = {
                headers: values.headers,
                APIendpoint: values.APIendpoint,
                successCode: values.successCode,
                bodyMapping: editModeBodyMappingData,
            }
            setEditDetails(hrisEditData);
            setShowConfirmModal(true);
        }
    }


    const goToEditMode = async () => {
        setIsEditMode(true);
    }

    //submit disable 
    const submitDisable = async () => {
        setModalActionButtonLoading(true);
        let response = await submitDisableHrisConnection();
        if (response.success == true) {
            getHrisDetails();
            setModalActionButtonLoading(false);
            setShowDisableModal(false);
        }
        else {
            getHrisDetails();
            setModalActionButtonLoading(false);
            setShowDisableModal(false);
        }
    }

    const submitEnable = async () => {
        setModalActionButtonLoading(true);
        let response = await submitEnableHrisConnection();
        if (response.success == true) {
            getHrisDetails();
            setModalActionButtonLoading(false);
            setShowEnableModal(false);
        }
        else {
            getHrisDetails();
            setModalActionButtonLoading(false);
            setShowEnableModal(false);
        }
    }

    //submit disconnect modal
    const submitDiconnect = async () => {
        setModalActionButtonLoading(true);
        let response = await submitDisconnectHrisConnection();
        if (response.success == true) {
            getHrisDetails();
            setShowDisconnectModal(false);
            setModalActionButtonLoading(false);
        }
        else {
            getHrisDetails();
            setShowDisconnectModal(false);
            setModalActionButtonLoading(false);
        }
    }


    //submit data
    const onSubmitConnectConfirm = async () => {
        setModalActionButtonLoading(true);
        //call API iont
        // setDataLoading(true);
        let response = await submitHrisConfigsAndConnect(submitDetails);
        if (response.success == true) {
            getHrisDetails();
            setShowConfirmModal(false);
            setModalActionButtonLoading(false);
        }
        else {
            setModalActionButtonLoading(false);
        }

    }

    //Edit data
    const onSubmitEditConfirm = async () => {
        setModalActionButtonLoading(true);
        //call API iont
        // setDataLoading(true);
        let response = await EditHrisConfigsAndConnect(editDetails);
        if (response.success == true) {
            getHrisDetails();
            setShowConfirmModal(false);
            setModalActionButtonLoading(false);
        }
        else {
            setModalActionButtonLoading(false);
        }

    }


    //get hris details
    const getHrisDetails = async () => {
        setDataLoading(true);
        let response = await getHrisData();
        if (response.success == true) {
            setDataLoading(false);

            // if connection is enabled
            if (response.data.is_webhook_enable === true && response.data.is_webhook_connected === true) {
                setWebhookEnable(true);
                setWebhookConnect(true);

                setAPIurl(response.data.api_url);
                setBodyMapping(JSON.parse(response.data.body_json_string));
                editModeBodyMappingPlaceholder = JSON.parse(response.data.body_json_string);
                setSuccessCode(response.data.success_response_code);
                setHeaders(response.data.headers);
            }
            //if connection is connected but not enabled
            else if (response.data.is_webhook_enable == false && response.data.is_webhook_connected == true) {
                setWebhookEnable(false);
                setWebhookConnect(true);

                setAPIurl(response.data.api_url);
                setBodyMapping(JSON.parse(response.data.body_json_string));
                editModeBodyMappingPlaceholder = JSON.parse(response.data.body_json_string);
                setSuccessCode(response.data.success_response_code);
                setHeaders(response.data.headers);
            }
            //if connection is disconnected
            else {

                setWebhookConnect(false);
                setWebhookEnable(false);

                setAPIurl('');
                setBodyMapping(defaultHRISRequestJsonBody);
                setSuccessCode('');
                setHeaders([]);
            }

            setIsEditMode(false);

        } else {
            setDataLoading(false);

        }
    }


    useEffect(() => {
        getHrisDetails();

    }, [])


    const EditHris = () => {
        return (
            <>
                <CustomConfirmationModal
                    show={showConfirmModal}
                    confirmationType='success'
                    cancelIconclick={handleClose}
                    onSecondaryBtnClick={handleClose}
                    onPrimaryBtnClick={isWebhookConnect ? onSubmitEditConfirm : onSubmitConnectConfirm}
                    isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    confirmationTopic="Are you sure?"
                    confirmationMessage={isWebhookConnect ? `You are trying to Edit details.` : `You are trying to save HRIS connection details.`}
                    secondaryBtnName="backBtn"
                    secondaryBtnType="button"
                    secondaryBtnLabel="Cancel"
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnLabel="Yes, submit!"
                />
                <div className={styles.accountContainerBox}>

                    <Row className="mt-4">

                        <Col className="align-self-center ml-4">
                            <Formik
                                validationSchema={schema}
                                initialValues={{
                                    APIendpoint: apiurl,
                                    headers: headersdata,
                                    successCode: successCode,
                                }
                                }
                                onSubmit={(values) => { isWebhookConnect ? onSubmitEdit(values) : onSubmitConnect(values) }}
                            >
                                {({ values,
                                    handleChange,
                                    errors,
                                    handleSubmit,
                                    setFieldValue,
                                    submitCount,
                                    touched


                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <Row >
                                            <Col sm={5} md={4} lg={3} xl={2} className="pl-4">
                                                <p className={styles.DetailsLabel}>API endpoint </p>
                                            </Col>
                                            <Col className="align-self-center">
                                                <CustomAlertBox
                                                    alertBodyText="Enter a publicly accessible REST POST API endpoint to submit hired candidate data, Allowed HTTPS endpoints only."
                                                    alertType="defaultAlert"
                                                />
                                                <CustomTextField
                                                    //label="Stage Name"
                                                    name="APIendpoint"
                                                    classLabel="defaultLabel"
                                                    controlId="APIendpoint"
                                                    placeholder="https://api.yourhris.com/create_employee"
                                                    type="text"
                                                    disabled={false}
                                                    value={values.APIendpoint}
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    errorMessage={errors.APIendpoint}
                                                    isInvalid={submitCount > 0 && !!errors.APIendpoint}
                                                />
                                            </Col>

                                        </Row>

                                        <Row className="mt-3">
                                            <Col sm={5} md={4} lg={3} xl={2} className="pl-4">
                                                <p className={styles.DetailsLabel}>Headers</p>
                                            </Col>
                                            <Col className="align-self-center">
                                                <CustomAlertBox
                                                    alertBodyText="Enter a  list of request headers  as required by your HRIS API. Enable Secure toggle to save them securly (if you enable Secure toggle, you won’t be able to see those values again."
                                                    alertType="defaultAlert"
                                                />


                                                <FieldArray name="headers">
                                                    {({ insert, remove, push }) => (
                                                        <div>
                                                            {
                                                                values.headers.length > 0 && values.headers.map((headers, index) => {
                                                                    const headersErrors = ((errors.headers?.length) && (errors.headers[index])) || {};
                                                                    const headersTouched = ((touched.headers?.length) && (touched.headers[index])) || {};


                                                                    return (

                                                                        < Row className='d-flex justify-content-between' key={index}>




                                                                            <Col lg={3}>
                                                                                <CustomTextField
                                                                                    //label="Stage Name"
                                                                                    name={`headers.${index}.key`}
                                                                                    classLabel="defaultLabel"
                                                                                    controlId={`headers.${index}.key`}
                                                                                    placeholder="key"
                                                                                    type="text"
                                                                                    disabled={false}
                                                                                    value={values.headers[index].key}
                                                                                    classType="defaultTextBox"
                                                                                    handleOnChange={handleChange}
                                                                                    errorMessage={(errors && errors.headers && errors.headers[index]) && errors.headers[index].key}
                                                                                    isInvalid={headersErrors.key && !!headersTouched.key}
                                                                                />
                                                                            </Col>

                                                                            <Col lg={6}>
                                                                                <CustomTextField
                                                                                    //label="Stage Name"
                                                                                    name={`headers.${index}.value`}
                                                                                    classLabel="defaultLabel"
                                                                                    controlId={`headers.${index}.value`}
                                                                                    placeholder="https://api.yourhris.com/create_employee"
                                                                                    type="text"
                                                                                    disabled={false}
                                                                                    value={values.headers[index].value}
                                                                                    classType="defaultTextBox"
                                                                                    handleOnChange={handleChange}
                                                                                    errorMessage={(errors && errors.headers && errors.headers[index]) && errors.headers[index].value}
                                                                                    isInvalid={headersErrors.value && !!headersTouched.value}
                                                                                />
                                                                            </Col>

                                                                            <Col className='ml-3'>
                                                                                <Row>
                                                                                    <Col className='mt-2'>
                                                                                        <p className={styles.DetailsLabel}>Secure</p>
                                                                                    </Col>
                                                                                    <Col>

                                                                                        <CustomSwitchButtonRow
                                                                                            id={`headers.${index}.is_secured`}
                                                                                            name={`headers.${index}.is_secured`}
                                                                                            //description="Grant ability to add new users"
                                                                                            isChecked={values.headers[index].is_secured}
                                                                                            handleClick={(checked) =>
                                                                                                setFieldValue(`headers.${index}.is_secured`, checked.target.checked)
                                                                                            }
                                                                                        />
                                                                                    </Col>
                                                                                    <Col className='mt-2'>
                                                                                        <div
                                                                                            type="button"
                                                                                            className={styles.cancelIconDiv}
                                                                                            onClick={() => remove(index)}
                                                                                        >
                                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                <path d="M13.5 4.5L4.5 13.5" stroke="#BDBDBD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                <path d="M4.5 4.5L13.5 13.5" stroke="#BDBDBD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                            </svg>
                                                                                        </div>

                                                                                    </Col>


                                                                                </Row>


                                                                            </Col>
                                                                        </Row>

                                                                    )
                                                                })}

                                                            <Row>
                                                                <Col lg={3}>
                                                                    <CustomButton
                                                                        id="hris_webhook_headers_add_btn"
                                                                        name="respondAcceptBtn"
                                                                        buttonType="button"
                                                                        type="defaultBtn"
                                                                        label="Add Header"
                                                                        handleClick={() => push({ key: '', value: '', is_secured: false, })}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    )}
                                                </FieldArray>


                                            </Col>

                                        </Row>


                                        {/* Body MApping */}

                                        <Row className="mt-3">
                                            <Col sm={5} md={4} lg={3} xl={2} className="pl-4">
                                                <p className={styles.DetailsLabel}>Body Mapping</p>
                                            </Col>
                                            <Col className="align-self-center">
                                                <CustomAlertBox
                                                    alertBodyText="Enter the  json body format as required by your HRIS API. Use these placeholders to set real values dynamically.
                                                    for candidate first name - {first_name} ,  for candidate last name - {last_name}, for candidate email- {email}, for candidate phone- {phone}, for candidate hired date - {hired_date}"
                                                    alertType="defaultAlert"
                                                />


                                                < Row className='d-flex justify-content-between ml-2'>
                                                    <JSONInput
                                                        id="jsonValue"
                                                        placeholder={editModeBodyMappingPlaceholder}
                                                        locale={locale}
                                                        height="200px"
                                                        //waitAfterKeyPress={placeholderData == null ? 1000000 : 1000}
                                                        //value = {values.json}
                                                        //reset={false}
                                                        //onKeyPressUpdate={placeholderData == null ? true : false}
                                                        // onKeyPressUpdate={false}
                                                        onBlur={(values) => onUpdateCompleted(values)}
                                                    />


                                                </Row>
                                                {/* <Row>
                                                    <Col>
                                                        {
                                                            Object.keys(jsonErr).map((key) => {
                                                                return <div className={`${styles.errorDiv} ${styles.errorMsg}`} style={{ color: "red" }}>{jsonErr[key]}</div>
                                                            })}
                                                    </Col>

                                                </Row> */}

                                            </Col>
                                        </Row>

                                        <Row className="mt-3">

                                            <Col sm={5} md={4} lg={3} xl={2} className="pl-4">
                                                <p className={styles.DetailsLabel}>Success Code </p>
                                            </Col>
                                            <Col className="align-self-center">
                                                <CustomAlertBox
                                                    alertBodyText="Enter the success response status code according to the HRIS API."
                                                    alertType="defaultAlert"
                                                />
                                                <CustomTextField
                                                    //label="Stage Name"
                                                    name="successCode"
                                                    classLabel="defaultLabel"
                                                    controlId="successCode"
                                                    placeholder="200"
                                                    type="text"
                                                    disabled={false}
                                                    value={values.successCode}
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    errorMessage={errors.successCode}
                                                    isInvalid={submitCount > 0 && !!errors.successCode}
                                                />
                                            </Col>

                                        </Row>


                                        <Row className={styles.btnRow}>


                                            <Col lg={2}>
                                                <div className={styles.disconnectButton} >
                                                    <CustomButton
                                                        id="hris_webhook_save_confirm"
                                                        type="primaryBtn"
                                                        label="Connect"
                                                        buttonType="submit"
                                                        // onClick={() => onClickConfirm()}
                                                        // backicon={isGoogleConnectionLoading ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                                        disabled={(props.main_props.permissions.actions.edit_settings === false) ? true : false}
                                                    //handleClick={() => onClickConfirm(values)}
                                                    // handleClick={() => jsonValidation()}
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={2}>
                                                <div className={styles.disconnectButton} >
                                                    <CustomButton
                                                        id="hris_webhook_save_cancel"
                                                        type="defaultBtn"
                                                        label="Cancel"
                                                        buttonType="button"
                                                        // disabled={(props.main_props.permissions.actions.edit_settings === false && props.main_props.role === 1) ? false : true}
                                                        // backicon={isGoogleConnectionLoading ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                                        // disabled={isGoogleConnectionLoading || isMicrosoftConnectionLoading ? true : false}
                                                        handleClick={() => setIsEditMode(!isEditMode)}
                                                    />
                                                </div>
                                            </Col>

                                        </Row>




                                    </Form>
                                )}
                            </Formik>



                        </Col>
                        <Col lg={1} className="ml-5">
                        </Col>
                    </Row>
                </div>

            </>
        )
    }

    const ViewHris = () => {
        return (
            <>
                {/* disable */}
                <CustomConfirmationModal
                    show={showDisableModal}
                    confirmationType='warning'
                    cancelIconclick={handleClose}
                    onSecondaryBtnClick={handleClose}
                    onPrimaryBtnClick={submitDisable}
                    isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    confirmationTopic="Are you sure?"
                    confirmationMessage={`You are trying to disable HRIS webbhook connectivity.`}
                    secondaryBtnName="backBtn"
                    secondaryBtnType="button"
                    secondaryBtnLabel="Cancel"
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnLabel="Yes, Disable!"
                    secondaryBtnId={'hris_disenable_cancel_confirm'}
                    primaryBtnId={'hris_disenable_save_confirm'}
                />

                {/* enable */}
                <CustomConfirmationModal
                    show={showEnableModal}
                    confirmationType='success'
                    cancelIconclick={handleClose}
                    onSecondaryBtnClick={handleClose}
                    onPrimaryBtnClick={submitEnable}
                    isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    confirmationTopic="Are you sure?"
                    confirmationMessage={`You are trying to re enable the HRIS webbhook connectivity.`}
                    secondaryBtnName="backBtn"
                    secondaryBtnType="button"
                    secondaryBtnLabel="Cancel"
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnLabel="Yes, Enable!"
                    secondaryBtnId={'hris_enable_cancel_confirm'}
                    primaryBtnId={'hris_enable_save_confirm'}
                />
                {/* disconnect */}
                <CustomConfirmationModal
                    show={showDisconnectModal}
                    confirmationType='danger'
                    cancelIconclick={handleClose}
                    onSecondaryBtnClick={handleClose}
                    onPrimaryBtnClick={submitDiconnect}
                    isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                    primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    confirmationTopic="Are you sure?"
                    confirmationMessage={`You are trying to disconnect the HRIS webbhook connectivity.`}
                    secondaryBtnName="backBtn"
                    secondaryBtnType="button"
                    secondaryBtnLabel="Cancel"
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnLabel="Yes, Disconnect!"
                    secondaryBtnId={'hris_disconnect_cancel_confirm'}
                    primaryBtnId={'hris_disconnect_save_confirm'}
                />

                <div className={styles.accountContainerBox}>

                    <Row className="mt-4">

                        <Col className="ml-4">
                            <Row >
                                <Col className="pl-4">
                                    <Row>
                                        <Col lg={3}>
                                            <p className={styles.DetailsLabel}>1.&nbsp;API endpoint</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.DetailsValue}>{apiurl ? apiurl : 'Not Available'}</p>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">

                                        <Col lg={3}>
                                            <p className={styles.DetailsLabel}>2.&nbsp;Headers</p>
                                        </Col>
                                        <Col className='ml-3'>
                                            {(headersdata.length > 0) && headersdata.map((headersdata) => {

                                                return (
                                                    <div>
                                                        <Row>
                                                            <p className={styles.DetailsValue}> {headersdata.key} : {headersdata.value}</p>
                                                        </Row>
                                                    </div>
                                                )

                                            })}
                                            {(headersdata.length < 1) &&
                                                <Row>
                                                    <p className={styles.DetailsValue}>Not Available</p>
                                                </Row>}


                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col lg={3}>
                                            <p className={styles.DetailsLabel}>3.&nbsp;Body Mapping</p>
                                        </Col>
                                        <Col className=''>

                                            <p className={styles.DetailsValue}>{bodyMappingdata ? JSON.stringify(bodyMappingdata) : 'Not Available'}</p>


                                        </Col>
                                    </Row>
                                    <Row className='mt-2'>
                                        <Col lg={3}>
                                            <p className={styles.DetailsLabel}>4.&nbsp;Success Code</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.DetailsValue}>{successCode ? successCode : ' Not Available'}</p>
                                        </Col>
                                    </Row>


                                </Col>

                            </Row>


                        </Col>
                        <Col lg={2}>
                            <Row className={styles.btnRow2}>
                                <Col  className={styles.btnRow2BtnArray}>
                                    <>
                                        {/* disconnect button */}
                                        {isWebhookConnect &&

                                            <CustomIconButton
                                                id="hris_webhook_disconnect"
                                                type="dangerBtn"
                                                showToolTip={true}
                                                toolTipId={'disconnect_webhook_tool_tip'}
                                                toolTip={'Disconnect Webhook Configurations'}
                                                icon={
                                                    <svg width="15" height="15" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8736 21.3168C11.633 21.8521 12.5585 22.1667 13.5563 22.1667L19.3896 22.1667V24.5H21.723L21.723 9.43417L19.3896 11.9897L19.3896 19.8333L13.5563 19.8333C13.1652 19.8333 12.7963 19.7367 12.4722 19.566L10.8736 21.3168ZM9.51732 19.8361L11.2618 17.9255C11.2363 17.7875 11.223 17.6453 11.223 17.5V10.5C11.223 9.21317 12.2695 8.16667 13.5563 8.16667L19.3896 8.16667V9.02355L21.723 6.468V3.5H19.3896V5.83333L13.5563 5.83333C10.9826 5.83333 8.88965 7.92633 8.88965 10.5V12.8333H3.05631L3.05631 15.1667H8.88965V17.5C8.88965 18.3506 9.11827 19.1487 9.51732 19.8361ZM26.3896 10.5V8.16667H22.8896V10.5H26.3896ZM26.3896 19.8333V17.5H22.8896V19.8333H26.3896Z" >
                                                        </path>
                                                        <line x1="23.9341" y1="5.17596" x2="7.99907" y2="21.9963"  stroke-width="1.5"></line>
                                                    </svg>
                                                }
                                                handleClick={() => onClickDisconnect()}
                                            />
                                        }
                                        {/* enable button */}
                                        {isWebhookConnect && !isWebhookEnable &&
                                            <CustomIconButton
                                                id="hris_webhook_enable"
                                                type="successBtn"
                                                showToolTip={true}
                                                toolTipId={'enable_webhook_tool_tip'}
                                                toolTip={'Enable Webhook Configurations'}
                                                icon={
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
                                                }
                                                handleClick={() => onClickEnable()}
                                            />
                                        }

                                        {/* disable */}
                                        {isWebhookConnect && isWebhookEnable &&
                                            <CustomIconButton
                                                id="hris_webhook_disable"
                                                type="dangerBtn"
                                                toolTipId={'disable_webhook_tool_tip'}
                                                showToolTip={true}
                                                toolTip={'Disable Webhook Configurations'}
                                                icon={
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="#EB5757" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-pause"><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></svg>
                                                }
                                                handleClick={() => onClickDisable()}
                                            />
                                        }
                                        {isWebhookConnect &&

                                            <CustomIconButton
                                                id="hris_webhook_edit"
                                                type="secondaryBtn"
                                                showToolTip={true}
                                                toolTipId={'edit_webhook_tool_tip'}
                                                toolTip={'Edit Webhook Configurations'}
                                                icon={
                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                }
                                                handleClick={() => goToEditMode()}
                                            />
                                        }
                                    </>
                                </Col>
                            </Row>



                        </Col>
                    </Row>

                </div >

            </>
        )
    }



    return (
        <div>
            {isDataLoading === true ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <div className={styles.mainOuterCard}>
                        <div>
                            <Row className={styles.rowWithNoSideMargin}>
                                <Col sm={10} >
                                    <Row>
                                        <span className={styles.mainCardTopic}>Webhook Integration</span>


                                        {
                                            !isEditMode && isWebhookEnable &&
                                            <>
                                                <div className='ml-5'>
                                                    <CustomStatusLabel type={'successStatus'} label={'Enabled'}></CustomStatusLabel>
                                                </div>
                                            </>
                                        }

                                        {
                                            !isEditMode && !isWebhookEnable && isWebhookConnect &&
                                            <>
                                                <div className='ml-5'>
                                                    <CustomStatusLabel type={'warningStatus'} label={'Disabled'}></CustomStatusLabel>
                                                </div>
                                            </>
                                        }

                                        {
                                            !isEditMode && !isWebhookConnect &&
                                            <>
                                                <div className='ml-5'>
                                                <CustomStatusLabel type={'warningStatus'} label={'Not Connected'}></CustomStatusLabel>
                                                </div>
                                            </>
                                        }
                                        
                                    </Row>
                                    <Row>
                                        <span className={styles.mainCardDescription}>Integrate with your organization’s HRIS. Then you can push hired candidates to HRIS directly.</span>
                                    </Row>
                                    
                                </Col>
                                <Col sm={2} className={styles.colWithNoSidePadding}>
                                        {/* connect button */}
                                        {!isWebhookConnect &&
                                            <CustomButton
                                                showToolTip={(props.main_props.permissions.actions.edit_settings === false) ? true : false}
                                                toolTip={`Permission Denied`}
                                                toolTipId={`permissionDenied`}
                                                type="primaryBtn"
                                                label="Connect"
                                                buttonType="submit"
                                                handleClick={goToEditMode}
                                                disabled={(props.main_props.permissions.actions.edit_settings === false) ? true : false}
                                            />}
                                    </Col>
                            </Row>
                            

                            

                            {
                                isEditMode == true ? (
                                    <>
                                        <EditHris />
                                    </>
                                )
                                    : null
                            }
                            {
                                isEditMode == false ? (
                                    <>
                                        <ViewHris />
                                    </>
                                )
                                    : null
                            }

                        </div>
                    </div>
                </div >
            }
        </div >
    )
}

export default HrisIntegration
